import api from "api";
import ApiCaller from "api/apiCaller";
import DataPipeline from "model/data_pipeline";
import React, { useState, useEffect } from "react";
import { useRouteMatch, useLocation } from "react-router-dom";
import {
  Col,
  Row,
  Container,
  Table,
} from "reactstrap";
import "./index.css";
import * as utils from "../../../resources/utils"

export default function DataPipelineLog() {
  const companyId = api.getCurrentCompanyId();
  const match = useRouteMatch("/data_pipeline_log/:data_pipeline_id");
  const params: any = match?.params;
  const dataPipelineId = params?.data_pipeline_id;
  const [dataPipeline, setDataPipeline] = useState<DataPipeline>({});
  const [dataPipelineLogs, setDataPipelineLogs] = useState([]);
  const getDataPipelineLogs = async () => {
    const res:any = await ApiCaller.get(`pipeline/${dataPipelineId}/run_log?company_id=${companyId}`);
    if (res.data) {
      setDataPipelineLogs(res.data.pipeline_run_logs);
      setDataPipeline(res.data.pipeline)
    }
  };
  const goToDataPipelineLog = (runLogId:any) => {
    window.location.href = `/data_pipeline/view/${dataPipeline.id}?data_pipeline_run_log_id=${runLogId}`;
  };
  useEffect(() => {
    getDataPipelineLogs();
  }, []);
  return (
    <Container>
      <Row>
        <Col xs={12}>
          <h3>{dataPipeline.name} log</h3>
        </Col>
        <Col xs={12} className="data-pipeline-log__table__container">
          <Table striped>
            <thead>
              <tr>
                <th>Run index</th>
                <th>Start time</th>
                <th>Duration</th>
                <th>Run type</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {dataPipelineLogs.map((dataPipelineLog:any) =>
                <tr key={dataPipelineLog.id} onClick={() => goToDataPipelineLog(dataPipelineLog.id)}>
                  <th scope="row">#{dataPipelineLog.id}</th>
                  <td>{dataPipelineLog.start_time}</td>
                  <td>{parseInt(dataPipelineLog.duration, 10)}s</td>
                  <td>{dataPipelineLog.run_type}</td>
                  <td>{utils.default.renderStatusIcon(dataPipelineLog.status)}</td>
                </tr>
              )}
            </tbody>
          </Table>
        </Col>
      </Row>
    </Container>
  );
}
